export type ClaimSum = {
  paid_amount: number;
  original_amount: number;
  disputed_amount: number;
};

/**
 * key is the currency of the sum
 */
export type ClaimSums = Record<string, ClaimSum>;

export function claimSumRemainingAmount(sum: ClaimSum): number {
  return sum.original_amount - sum.paid_amount - sum.disputed_amount;
}
